<mat-sidenav-container class="nav-container">
  <div id="top-menu" fxLayout="row" fxLayoutAlign="space-between center">
    <div id="user-menu">
      <p>
        Welcome, {{userName}}
      </p>
    </div>
    <div *ngIf="isAuthenticated" fxLayout="row" fxLayoutAlign="center center">
      <a [routerLink]="['/user-profile']" id="profile">
        <span>{{abbreviation}}</span>
      </a>
      <a (click)="logout()">
        Sign out
      </a>
    </div>
  </div>
  <app-maintenance-banner></app-maintenance-banner>
  <mat-sidenav #appDrawer mode="side" opened="true" class="text-center">
    <div class="mt-3">
      <a [routerLink]="['/']" class="logo mat-list-item">
        <img class="logo" width="220px" src="../../../assets/img/Logo.svg" alt="Texas Capital Bank admin portal.">
      </a>
    </div>
    <router-outlet></router-outlet>
    <mat-nav-list>
      <app-menu-list-item *ngFor="let item of accessibleNavItems" [item]="item"></app-menu-list-item>
    </mat-nav-list>
  </mat-sidenav>
  <router-outlet></router-outlet>
</mat-sidenav-container>
